import type {FC} from 'react';
import {Checkbox} from 'src/design/atoms/Checkbox';

/**
 * Labeled checkbox row with a fixed size/spacing preset and optional help
 * text rendered as the checkbox's description.
 * @registry Preset checkbox row (size md, bottom padding) with helper text.
 *
 * Ported from `library/forms/FormCheckboxRow/FormCheckboxRow`. Renamed
 * `FormCheckboxRow` -> `CheckboxRow`. Prop surface kept identical.
 */
export interface CheckboxRowProps {
  checked: boolean;
  label?: React.ReactNode;
  id?: string;
  disabled?: boolean;
  helpText?: string;
  onChange: (
    event: React.ChangeEvent<HTMLInputElement>,
    checked: boolean
  ) => void;
}

export const CheckboxRow: FC<CheckboxRowProps> = ({
  checked,
  label,
  helpText,
  disabled,
  onChange,
}) => {
  return (
    <Checkbox
      label={label}
      checked={checked}
      size="md"
      pb="md"
      onChange={(e, checked) => onChange(e, checked)}
      description={helpText}
      disabled={disabled}
    />
  );
};
